const BASE = process.env.REACT_APP_API_URL || "http://localhost:8001";

// Transporte público sin token, cookies ni redirecciones de sesión.
export async function pedirReserva(slug, recurso, body, signal) {
  const controller = new AbortController();
  const abortar = () => controller.abort();
  const timeout = setTimeout(abortar, 15000);
  if (signal?.aborted) controller.abort();
  signal?.addEventListener("abort", abortar);
  try {
    const response = await fetch(`${BASE}/api/publico/reservas/${encodeURIComponent(slug)}/${recurso}`, {
      method: body ? "POST" : "GET", credentials: "omit", signal: controller.signal,
      headers: body ? { "Content-Type": "application/json" } : {},
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    if (!response.ok) {
      const error = new Error("reserva");
      error.status = response.status;
      throw error;
    }
    return { data: await response.json(), hoy: response.headers?.get("X-Reserva-Hoy") };
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener("abort", abortar);
  }
}

export function fechaMexico() {
  const partes = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Mexico_City", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date());
  const p = Object.fromEntries(partes.map(({ type, value }) => [type, value]));
  return `${p.year}-${p.month}-${p.day}`;
}

export function sumarDias(fecha, dias) {
  const date = new Date(`${fecha}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + dias);
  return date.toISOString().slice(0, 10);
}

export function telefonoValido(value) {
  const telefono = value.trim();
  const digitos = telefono.replace(/[^0-9]/g, "").length;
  return telefono.length <= 40 && /^\+?[0-9\s().-]+$/.test(telefono) && digitos >= 8 && digitos <= 15;
}

export function correoValido(value) {
  // EmailStr admite dominios internacionales; URL convierte el dominio a ASCII.
  const correo = value.trim().normalize("NFC");
  if (correo.length > 254 || /[\s<>]/.test(correo)) return false;
  const partes = correo.split("@");
  if (partes.length !== 2 || !partes[0] || partes[0].length > 64 || partes[0].startsWith(".") || partes[0].endsWith(".") || partes[0].includes("..")) return false;
  if (!/^[\p{L}\p{N}!#$%&'*+\-/=?^_`{|}~.]+$/u.test(partes[0])) return false;
  try {
    if (["\\", "/", ":", "?", "#", "%", "[", "]"].some((c) => partes[1].includes(c))) return false;
    const host = new URL(`https://${partes[1]}`).hostname;
    return host.length <= 253 && host.includes(".") && host.split(".").every((p) => p.length <= 63 && /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(p))
      && !/^\d+(\.\d+)+$/.test(host) && !["arpa", "invalid", "local", "localhost", "onion", "test"].includes(host.split(".").pop());
  } catch { return false; }
}
